import { render, staticRenderFns } from "./TCs.vue?vue&type=template&id=5b58d7af"
import script from "./TCs.vue?vue&type=script&lang=js"
export * from "./TCs.vue?vue&type=script&lang=js"
import style0 from "./TCs.vue?vue&type=style&index=0&id=5b58d7af&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports